import CoreMaterial from "../../rendering/star/core-material";

class Core extends THREE.Mesh {
    constructor({ star, temperature, map, normalMap }) {
        const geometry = new THREE.SphereBufferGeometry(6, 32, 32);
        const material = new CoreMaterial({ temperature, map, normalMap });

        super(geometry, material);
        this.type = "Core";
        this.star = star;
        this.overridePicker = star;
        this.isStarCore = true;
    }

    update(time) { this.material.uniforms.time.value = time; }
}

export default Core;
export { Core };